import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ForgotPage } from './forgot';

@NgModule({
  declarations: [
    ForgotPage,
  ],
  imports: [
    IonicPageModule.forChild(ForgotPage),
  ],
})
export class ForgotPageModule {}



// WEBPACK FOOTER //
// ./src/pages/forgot/forgot.module.ts